/**
 * API service for fetching products from the intranet products endpoint
 */

const API_URL = '/intranet/produkte/api';
const CATEGORIES_URL = '/intranet/produkte/categories';

/**
 * Fetch products with filters, search, and pagination
 *
 * @param {Object} params - Query parameters
 * @param {string} params.search - Search query
 * @param {Array} params.categories - Category IDs to filter by
 * @param {Object} params.filters - Property filters (wuchsformen, etc.)
 * @param {number} params.page - Page number (1-based)
 * @returns {Promise<Object>} API response with data and meta
 */
export async function fetchProducts({ search = '', categories = [], filters = {}, page = 1 }) {
    const params = new URLSearchParams();

    // Add search query
    if (search) {
        params.append('q', search);
    }

    // Add category filters
    categories.forEach(categoryId => {
        params.append('category[]', categoryId);
    });

    // Add property filters
    Object.entries(filters).forEach(([filterKey, values]) => {
        if (Array.isArray(values) && values.length > 0) {
            values.forEach(value => {
                params.append(`${filterKey}[]`, value);
            });
        }
    });

    // Add pagination
    params.append('page', page);

    // Fetch data
    const response = await fetch(`${API_URL}?${params.toString()}`);

    if (!response.ok) {
        throw new Error(`API error: ${response.status}`);
    }

    return response.json();
}

/**
 * Fetch all product categories
 *
 * @returns {Promise<Array>} Array of category objects with slug, title, and parent
 */
export async function fetchCategories() {
    const response = await fetch(CATEGORIES_URL);

    if (!response.ok) {
        throw new Error(`API error: ${response.status}`);
    }

    return response.json();
}
